@use "../../../globals/bcp";
@use "../../../globals/forwards/typography";

.h1 {
  @include typography.h1();
}

.h2 {
  @include typography.h2();
}

.h3 {
  @include typography.h3();
}

.h4 {
  @include typography.h4();
}

.h5 {
  @include typography.h5();
}

.h6 {
  @include typography.h6();
}

.p,
.span,
.div {
  @include typography.p();
}

.s {
  @include typography.s();
}

.text-s {
  @include typography.text-s();
}

.text-m {
  @include typography.text-m();
}

.text-l {
  @include typography.text-l();
}

.text-ll {
  @include typography.headline-l();
}

.text-xl {
  @include typography.text-xl();
}

.text-2xl {
  @include typography.text-2xl();
}

.text-3xl {
  @include typography.text-3xl();
}

.text-4xl {
  @include typography.text-4xl();
}

.text-5xl {
  @include typography.text-5xl();
}

.text-6xl {
  @include typography.text-6xl();
}

.no-margin {
  margin-top: 0;
  margin-bottom: 0;
}

.u-font-normal {
  font-weight: bcp.$font-weight-normal;
}

.u-font-bold {
  font-weight: bcp.$font-weight-bold;
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
